export default __webpack_public_path__ + "static/Entenda0027-8d4a87abc554e7dc5ffd168885a12de5.jpg";